import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { TDocumentDefinitions, Content } from 'pdfmake/interfaces';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { ComplaintsService } from './complaints.service';
import Swal from 'sweetalert2';
import { MainService } from '../../portal/service/main.service'
// import { layouts } from 'chart.js';


// (pdfMake as any).vfs = (pdfFonts as any).vfs;



@Injectable({
  providedIn: 'root'
})
export class PdfGeneratorService {

  constructor(private mainService: MainService, private http: HttpClient, private cs: ComplaintsService) { }

  async getcomplaints(b_acct_id: any, com_id: any) {
    let resp = await this.cs.getComplaints(JSON.stringify({ b_acct_id, com_id }));
    return resp;
  }

  extractEnglishDepartments(deptStr: string): string {
    try {
      const parsedArray = JSON.parse(deptStr);
      const englishNames = parsedArray.map((item: any) => {
        const key = Object.keys(item)[0];
        const fullText = item[key];
        return fullText.replace(/\s*\([^)]*\)/g, '').trim();
      });
      return englishNames.join(', ');
    } catch (err) {
      console.error('Failed to parse dept:', err);
      return '-';
    }
  }

  private isImageDataUrl(value: any): value is string {
    return typeof value === 'string' && /^data:image\/(png|jpeg|jpg);base64,/.test(value);
  }

  private async resolveLogoDataUrl(): Promise<string | null> {
    const logoValue = this.mainService.accountLogoUrl;
    if (this.isImageDataUrl(logoValue)) {
      return logoValue;
    }
    if (this.mainService.accountImageUrlblob instanceof Blob && this.mainService.accountImageUrlblob.type.startsWith('image/')) {
      const dataUrl = await this.mainService.blobToBase64(this.mainService.accountImageUrlblob);
      return this.isImageDataUrl(dataUrl) ? dataUrl : null;
    }
    const fallbackPath = typeof logoValue === 'string' ? logoValue : '/assets/img/account.png';
    try {
      const blob = await this.http.get(fallbackPath, { responseType: 'blob' }).toPromise();
      if (blob && blob.type.startsWith('image/')) {
        const dataUrl = await this.mainService.blobToBase64(blob);
        return this.isImageDataUrl(dataUrl) ? dataUrl : null;
      }
      return null;
    } catch {
      return null;
    }
  }

  async loadFonts() {
    const fontsToLoad = [
      { name: 'NotoSansDevanagari-Regular.ttf', path: '/assets/font/NotoSansDevanagari-Regular.ttf' },
      { name: 'NotoSansDevanagari-Bold.ttf', path: '/assets/font/NotoSansDevanagari-Bold.ttf' },
      { name: 'Kruti_Dev.ttf', path: '/assets/font/Kruti_Dev.ttf' }
    ];

    for (const font of fontsToLoad) {
      if (!(pdfMake as any).vfs[font.name]) {
        try {
          const blob = await this.http.get(font.path, { responseType: 'blob' }).toPromise();
          if (blob) {
            const base64 = await this.mainService.blobToBase64(blob);
            (pdfMake as any).vfs[font.name] = (base64 as string).split(',')[1];
          }
        } catch (error) {
          console.error(`Error loading font ${font.name}:`, error);
        }
      }
    }

    (pdfMake as any).fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      },
      NotoSans: {
        normal: 'NotoSansDevanagari-Regular.ttf',
        bold: 'NotoSansDevanagari-Bold.ttf',
        italics: 'NotoSansDevanagari-Regular.ttf',
        bolditalics: 'NotoSansDevanagari-Bold.ttf'
      },
      KrutiDev: {
        normal: 'Kruti_Dev.ttf',
        bold: 'Kruti_Dev.ttf',
        italics: 'Kruti_Dev.ttf',
        bolditalics: 'Kruti_Dev.ttf'
      }
    };
  }
  // Add this method in your PdfGeneratorService class
  private splitTextByScript(text: string): any[] {
    if (!text || text.trim() === '-' || text.trim() === '') {
      return [{ text: text || '-', font: 'Roboto' }];
    }

    // One single regex that splits on script change in ONE pass
    const parts = text.match(/[\u0900-\u097F]+|[^\u0900-\u097F]+/g) || [];

    return parts.map(part => ({
      text: part,
      font: /[\u0900-\u097F]/.test(part) ? 'NotoSans' : 'Roboto'
    }));
  }
  private getFontForText(text: string): string {
    if (!text || text === '-') return 'Roboto';
    return /[\u0900-\u097F]/.test(text) ? 'NotoSans' : 'Roboto';
  }
  async generateComplaintPDF(b_acct_id: string, com_id: any): Promise<void> {
    try {
      await this.loadFonts();
      const resp: any = await this.getcomplaints(b_acct_id, com_id);

      if (resp.error || !resp.data || resp.data.length < 1) {
        Swal.fire('Oops !!', `Unable to process your request. Please try again later.`, 'info');
        return;
      }

      const data = resp.data[0];
      const timestamp = data.create_timestamp || data.created_time;

      const formattedTime = new Date(timestamp).toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      const logoDataUrl = await this.resolveLogoDataUrl();
      const ticketIcon = '<svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.2061 3.45398C11.6979 3.17289 12.3021 3.17289 12.7939 3.45398L15.0039 4.71667C15.3113 4.89234 15.6887 4.89234 15.9961 4.71667L18.252 3.42761C18.5853 3.2372 19 3.47829 19 3.86218V20.1385C19 20.5224 18.5853 20.7634 18.252 20.5731L15.9961 19.2841C15.6887 19.1084 15.3113 19.1084 15.0039 19.2841L12.7939 20.5467C12.3021 20.8278 11.6979 20.8278 11.2061 20.5467L8.99609 19.2841C8.68866 19.1084 8.31134 19.1084 8.00391 19.2841L5.74805 20.5731C5.41475 20.7634 5 20.5224 5 20.1385V3.86218C5 3.47829 5.41473 3.2372 5.74805 3.42761L8.00391 4.71667C8.31133 4.89234 8.68867 4.89234 8.99609 4.71667L11.2061 3.45398ZM9.5 13.9999C9.22398 13.9999 9.0002 14.2239 9 14.4999C9 14.776 9.22386 14.9999 9.5 14.9999H14.5C14.7761 14.9999 15 14.776 15 14.4999C14.9998 14.2239 14.776 13.9999 14.5 13.9999H9.5ZM9.5 11.4999C9.22398 11.4999 9.0002 11.7239 9 11.9999C9 12.276 9.22386 12.4999 9.5 12.4999H14.5C14.7761 12.4999 15 12.276 15 11.9999C14.9998 11.7239 14.776 11.4999 14.5 11.4999H9.5ZM9.5 8.99987C9.22398 8.99987 9.0002 9.2239 9 9.49987C9 9.77602 9.22386 9.99987 9.5 9.99987H14.5C14.7761 9.99987 15 9.77602 15 9.49987C14.9998 9.2239 14.776 8.99987 14.5 8.99987H9.5Z" fill="#222222"/></svg>';
      const calendarIcon = '<svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2.75" y="6" width="16.5" height="15" rx="2" stroke="#222222"/><path d="M2.75 10C2.75 8.11438 2.75 7.17157 3.33579 6.58579C3.92157 6 4.86438 6 6.75 6H15.25C17.1356 6 18.0784 6 18.6642 6.58579C19.25 7.17157 19.25 8.11438 19.25 10H2.75Z" fill="#222222"/><path d="M6.41602 3L6.41601 6" stroke="#222222" stroke-linecap="round"/><path d="M15.584 3L15.584 6" stroke="#222222" stroke-linecap="round"/></svg>';
      const clockIcon = '<svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 3C15.5563 3 19.25 7.02944 19.25 12C19.25 16.9706 15.5563 21 11 21C6.44365 21 2.75 16.9706 2.75 12C2.75 7.02944 6.44365 3 11 3ZM11 5.5C10.4477 5.5 10 5.94772 10 6.5V11.75C10 12.4404 10.5596 13 11.25 13H14.208C14.7603 13 15.208 12.5523 15.208 12C15.208 11.4477 14.7603 11 14.208 11H12V6.5C12 5.94772 11.5523 5.5 11 5.5Z" fill="#222222"/></svg>';
      const tableLayout = {
        hLineWidth: function () { return 0.5; },
        vLineWidth: function () { return 0.5; },
        hLineColor: function () { return '#b0b0b0'; },
        vLineColor: function () { return '#b0b0b0'; }
      };
      const detailsTable: any = {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              { text: ['Full Name / ', { text: 'पूरा नाम:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
              // { text: data.full_name || '-', style: 'value' , border: [false, true, true, true] },
              {
                text: this.splitTextByScript(data.full_name || '-'),
                style: 'value',
                border: [false, true, true, true]
              },
              { text: ['Mobile Number / ', { text: 'मोबाइल नंबर:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
              { text: data.mobile_no || '-', style: 'value', border: [false, true, true, true] }
            ],
            [
              { text: ['Complaint Department / ', { text: 'शिकायत विभाग:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
              // { text: this.extractEnglishDepartments(data.dept), style: 'value',border: [false, true, true, true] },
              {
                text: this.splitTextByScript(this.extractEnglishDepartments(data.dept) || '-'),
                style: 'value',
                border: [false, true, true, true]
              },
              { text: ['Zone / ', { text: 'जोन:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
              // { text: data.zone || '-', style: 'value' ,border: [false, true, true, true] }
              {
                text: this.splitTextByScript(data.zone || '-'),
                style: 'value',
                border: [false, true, true, true]
              },
            ]
          ]
        },
        layout: tableLayout
      };

      const hasComDoc = data.com_doc && data.com_doc != 'N/A';
      const hasOtherDoc = data.others_doc && data.others_doc != 'N/A';

      if (hasComDoc || hasOtherDoc) {
        const row: any[] = [
          hasComDoc ? { text: ['Uploaded Document / ', { text: 'अपलोड किया गया दस्तावेज:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] } : { text: '', border: [false, false, false, false] },
          hasComDoc ? { text: data.com_doc, style: 'value', border: [false, true, true, true] } : { text: '', border: [false, false, false, false] },
          hasOtherDoc ? { text: ['Other Document (Optional) / ', { text: 'अन्य दस्तावेज (वैकल्पिक):', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] } : { text: '', border: [false, false, false, false] },
          hasOtherDoc ? { text: data.others_doc, style: 'value', border: [false, true, true, true] } : { text: '', border: [false, false, false, false] }
        ];

        // Adjust colspans if only one document exists to keep table structure valid
        if (hasComDoc && !hasOtherDoc) {
          row[1] = { text: data.com_doc, style: 'value', border: [false, true, true, true], colSpan: 3 };
          row[2] = {};
          row[3] = {};
        } else if (!hasComDoc && hasOtherDoc) {
          // If only other doc exists, we shift it to the left or keep it on right?
          // Usually better to fill from left. Let's put it in the first slot if it's the only one.
          row[0] = { text: ['Other Document (Optional) / ', { text: 'अन्य दस्तावेज (वैकल्पिक):', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] };
          row[1] = { text: data.others_doc, style: 'value', border: [false, true, true, true], colSpan: 3 };
          row[2] = {};
          row[3] = {};
        }

        detailsTable.table.body.push(row);
      }
      const detailsTable2: any = {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          heights: [420],
          body: [
            [
              { text: ['Complaint Description / ', { text: 'शिकायत विवरण:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
              // { text: data.complaint_desc || '-', style: 'value',font: this.getFontForText(data.complaint_desc), colSpan: 3, border: [false, true, true, true] },
              {
                text: this.splitTextByScript(data.complaint_desc || '-'),
                style: 'value',
                colSpan: 3,
                border: [false, true, true, true]
              },
              {},
              {}
            ]
          ]
        },
        margin: [0, 20, 0, 0],
        layout: tableLayout
      };

      const content = [
        {
          columns: [
            logoDataUrl ? { image: 'logo', width: 55, alignment: 'left' } : { text: ' ', width: 55 },
            {
              stack: [
                { text: 'Municipal Corporation, Lucknow', style: 'title', alignment: 'center' },
                {
                  text: [
                    { text: 'Sampurna Samadhan Diwas\n', style: 'subtitle' },
                    { text: '(संपूर्ण समाधान दिवस)', style: 'subtitle', font: 'NotoSans' }
                  ],
                  alignment: 'center',
                  margin: [0, 0, 0, 8]
                }
              ],
              width: '*'
            },
            { text: ' ', width: 55 }
          ],
          columnGap: 10,
          margin: [0, 0, 0, 10]
        },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 510, y2: 0, lineWidth: 0.5, lineColor: '#b0b0b0' }] },
        { text: ' ' },
        {
          columns: [
           {
  columns: [
    { svg: ticketIcon, width: 12, margin: [0, -2, 0, 0] },
    {
      text: [
        { text: 'Ticket Number / ', font: 'Roboto' },
        { text: 'टिकट संख्या: ', font: 'NotoSans' },
        ...this.splitTextByScript(data.ticket_id || '-')
      ],
      style: 'meta'
    }
  ],
  columnGap: 2,
  width: '*'
},
            {
              stack: [
                {
                  columns: [
                    { svg: calendarIcon, width: 12, margin: [0, -2, 0, 0] },
                    { text: ['Date / ', { text: 'दिनांक:', font: 'NotoSans' }], style: 'meta', width: 'auto', margin: [0, 0, 5, 0] },
                    { text: data.create_date, style: 'meta', width: 'auto' }
                  ],
                  columnGap: 2,
                  margin: [0, 0, 0, 2]
                },
                {
                  columns: [
                    { svg: clockIcon, width: 12, margin: [0, -2, 0, 0] },
                    { text: ['Time / ', { text: 'समय:', font: 'NotoSans' }], style: 'meta', width: 'auto', margin: [0, 0, 5, 0] },
                    { text: formattedTime, style: 'meta', width: 'auto' }
                  ],
                  columnGap: 2
                }
              ],
              alignment: 'right',
              width: 'auto'
            }
          ],
          margin: [0, 0, 0, 10]
        },
        detailsTable,
        detailsTable2,
        { text: ' ' }
      ];

      if (data.is_instant_resolved) {
        // Add Section Header Row
        detailsTable2.table.body.push([
          { text: ['Instant Resolution Details / ', { text: 'तत्काल समाधान विवरण', font: 'NotoSans' }], style: 'section', colSpan: 4, border: [false, false, false, false], margin: [0, 10, 0, 5] },
          {}, {}, {}
        ]);

        // Add Is Instant Resolved Row
        detailsTable2.table.body.push([
          { text: ['Is Instant Resolved / ', { text: 'क्या तत्काल समाधान हुआ:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
          { text: data.is_instant_resolved ? 'YES' : 'NO', style: 'value', colSpan: 3, border: [false, true, true, true] },
          {}, {}
        ]);

        // Add Remark Row
        detailsTable2.table.body.push([
          { text: ['Remark / ', { text: 'टिप्पणी:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
          // { text: (data.resolved_remark || '-').toString().trim(), style: 'value', colSpan: 3, border: [false, true, true, true] },
          {
            text: this.splitTextByScript((data.resolved_remark || '-').toString().trim()),
            style: 'value',
            colSpan: 3,
            border: [false, true, true, true]
          },
          {}, {}
        ]);

        // Add Approval Description Row
        detailsTable2.table.body.push([
          { text: ['Approval Description / ', { text: 'अनुमोदन विवरण:', font: 'NotoSans' }], style: 'label', border: [true, true, false, true] },
          // { text: (data.approval_desc || '-').toString().trim(), style: 'value',  colSpan: 3, border: [false, true, true, true] },
          {
            text: this.splitTextByScript((data.approval_desc || '-').toString().trim()),
            style: 'value',
            colSpan: 3,
            border: [false, true, true, true]
          },
          {}, {}
        ]);
      }

      content.push({
        columns: [
          {
            stack: [
              { text: 'संलग्नक ', font: 'NotoSans', bold: true, alignment: 'center' },
              { text: 'Attachments', bold: true, alignment: 'center' },
            ],
            width: 'auto',
            alignment: 'left'
          },
          { text: '', width: '*' },
          {
            stack: [
              { text: 'शिकायतकर्ता के हस्ताक्षर', font: 'NotoSans', bold: true, alignment: 'center' },
              { text: 'Applicant Signature', bold: true, alignment: 'center' }
            ],
            width: 'auto',
            alignment: 'right'
          },
        ],
        margin: [0, 30, 0, 0]
      });

      const dd: any = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [40, 60, 40, 60],
        // header: {
        //   stack: [
        //     { image: 'logo', width: 60, margin: [0, 0, 0, 40] },
        //     { text: 'Municipal Corporation, Lucknow', alignment: 'center', style: 'header' },
        //     { text: 'Sampurna Samadhan Diwas', alignment: 'center', style: 'subheader', margin: [0, 5, 0, 15] },
        //   ]
        // },


        footer: function (currentPage: any, pageCount: any) {
          return {
            columns: [
              { text: '', alignment: 'left', margin: [40, 0] },
              { text: ``, alignment: 'center', bold: true },
              { text: '', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 9 }
            ],
            margin: [40, 20]
          };
        },
        content: content,
        // defaultStyle: {
        //   font: 'NotoSans'
        // },
        styles: {
          title: {
            fontSize: 18,
            bold: true
          },
          subtitle: {
            fontSize: 12,
            italics: true
          },
          meta: {
            fontSize: 10,
            bold: true
          },
          label: {
            fontSize: 10,
            bold: true,
            margin: [5, 5, 5, 5]
          },
          value: {
            fontSize: 10,
            color: 'black',
            margin: [5, 5, 5, 5]
          },
          section: {
            fontSize: 11,
            bold: true
          }
        },
        images: {
          ...(logoDataUrl ? { logo: logoDataUrl } : {})
        }

      };


      pdfMake.createPdf(dd).open();
    } catch (error) {
      console.error('PDF generation failed:', error);
      Swal.fire('Error', 'Something went wrong while generating PDF.', 'error');
    }
  }

  detectFont(text: any): string {
    if (!text) return 'Roboto';
    const str = text.toString();
    const hasHindi = /[\u0900-\u097F]/.test(str);
    return hasHindi ? 'NotoSans' : 'Roboto';
  }

  async generateTablePDF(data: any[], title: string, headers: string[] = ['Sr.No.', 'Ticket Id', 'Department', 'Zone', 'Full Name', 'Mobile No.', 'Complaint Date']): Promise<void> {
    try {
      await this.loadFonts();
      const logoDataUrl = await this.resolveLogoDataUrl();

      const body: any[] = [
        headers.map(header => ({ text: header, style: 'tableHeader', font: this.detectFont(header) }))
      ];

      data.forEach((index_item, index) => {
        const item = index_item;
        const srNo = (index + 1).toString();
        const ticketId = item.ticket_id || '-';
        const dept = this.extractEnglishDepartments(item.dept) || '-';
        const zone = item.zone || '-';
        const fullName = item.full_name || '-';
        const mobile = item.mobile_no || '-';
        const date = item.create_date || '-';
        const status = item.status || '-';

        const row = [
          { text: srNo, style: 'tableBody', font: this.detectFont(srNo) },
          { text: ticketId, style: 'tableBody', font: this.detectFont(ticketId) },
          { text: dept, style: 'tableBody', font: this.detectFont(dept) },
          { text: zone, style: 'tableBody', font: this.detectFont(zone) },
          { text: this.splitTextByScript(fullName), style: 'tableBody'},
          // { text: fullName, style: 'tableBody', font: this.detectFont(fullName) },
          { text: mobile, style: 'tableBody', font: this.detectFont(mobile) },
          { text: date, style: 'tableBody', font: this.detectFont(date) }
        ];

        if (headers.length > 7) {
          row.push({ text: status, style: 'tableBody', font: this.detectFont(status) });
        }
        body.push(row);
      });

      const widths = headers.length > 7
        ? ['auto', 'auto', '*', '*', 'auto', 'auto', 'auto', 'auto']
        : ['auto', '*', '*', '*', 'auto', 'auto', '*'];

      const dd: any = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [20, 60, 20, 40],
        content: [
          {
            columns: [
              logoDataUrl ? { image: 'logo', width: 55, alignment: 'left' } : { text: ' ', width: 55 },
              { text: 'Municipal Corporation, Lucknow', style: 'title', alignment: 'center', width: '*' },
              { text: ' ', width: 55 }
            ],
            columnGap: 10,
            margin: [0, 0, 0, 10]
          },
          {
            text: [
              { text: 'Sampurna Samadhan Diwas\n', style: 'subtitle' },
              { text: '(संपूर्ण समाधान दिवस)', style: 'subtitle', font: 'NotoSans' }
            ],
            alignment: 'center',
            margin: [0, 0, 0, 8]
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 800, y2: 0, lineWidth: 0.5, lineColor: '#b0b0b0' }] }, // Extended line for landscape
          { text: ' ' },
          { text: title, style: 'subtitle', alignment: 'center', margin: [0, 0, 0, 20] },
          {
            table: {
              headerRows: 1,
              widths: widths,
              body: body
            },
            layout: {
              hLineWidth: function (i: number, node: any) {
                return 0.5;
              },
              vLineWidth: function (i: number, node: any) {
                return 0.5;
              },
              hLineColor: function (i: number, node: any) {
                return '#aaa';
              },
              vLineColor: function (i: number, node: any) {
                return '#aaa';
              },
              paddingLeft: function (i: number, node: any) { return 4; },
              paddingRight: function (i: number, node: any) { return 4; },
              paddingTop: function (i: number, node: any) { return 2; },
              paddingBottom: function (i: number, node: any) { return 2; }
            }
          }
        ],
        styles: {
          title: { fontSize: 18, bold: true },
          subtitle: { fontSize: 14, bold: true },
          tableHeader: { fontSize: 10, bold: true, fillColor: '#eeeeee' },
          tableBody: { fontSize: 10 }
        },
        images: {
          ...(logoDataUrl ? { logo: logoDataUrl } : {})
        }
      };

      pdfMake.createPdf(dd).open();
    } catch (error) {
      console.error('PDF generation failed:', error);
      Swal.fire('Error', 'Something went wrong while generating PDF.', 'error');
    }
  }

}
